import React, { useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import LoadingButton from '@mui/lab/LoadingButton';
import Close from '@mui/icons-material/Close';
import FlipCameraAndroid from '@mui/icons-material/FlipCameraAndroid';
import Check from '@mui/icons-material/Check';
import KendoReactEditor from './KendoReactEditor';

export const HtmlEditor = ({ field, html, handleChange }) => {
    const childRefReactEditor = useRef(null);
    const [value, setValue] = useState(html);
    const [open, setOpen] = useState(false);

    const handleOnChange = (content) => {
        setValue(content);
        handleChange(field.id, content.toString().replace(/"/g, "'"));
        setValue(content)
        console.log('content =>', content.toString().replace(/"/g, "'"));
    };

    const ResetChanges = () => {
        childRefReactEditor.current.ResetChanges();
    }

    const AcceptChanges = () => {
        childRefReactEditor.current.AcceptChanges();
    }

    return (
        <React.Fragment>
            <LoadingButton
                size='small'
                variant='outlined'
                color='info'
                onClick={() => setOpen(true)}
            >
                Html templete
            </LoadingButton>
            <Dialog
                open={open}
                fullWidth
                maxWidth='lg'
                PaperProps={{
                    style: { height: '95%', overflow: 'visible' }
                }}
            >
                <DialogTitle>
                    <Typography variant='h5' component='h5'>
                        Editor Html
                    </Typography>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex' }}>
                    </Box>

                    <Box
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Tooltip title='Actualizar cambios'>
                            <IconButton
                                color="success"
                                onClick={() => AcceptChanges()}
                            >
                                <Check />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='Desacer cambios'>
                            <IconButton
                                color="error"
                                onClick={() => ResetChanges()}
                            >
                                <FlipCameraAndroid />
                            </IconButton>
                        </Tooltip>
                        <IconButton
                            aria-label='close'
                            onClick={() => setOpen(false)}
                        // sx={{
                        //     position: 'absolute',
                        //     right: 8,
                        //     top: 8,
                        //     color: (theme) => theme.palette.grey[500],
                        // }}
                        >
                            <Close />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <KendoReactEditor
                        html={value}
                        handleChange={handleOnChange}
                        ref={childRefReactEditor}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};
